'use strict';

module.exports = function() {
	this.getDimensions();
	this.canvas.setAttribute('width', this.x1);
	this.canvas.setAttribute('height', this.y1);
	if (this.image) this.prepareImage();
	this.refreshColors();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/granim/lib/setSizeAttributes.js
// module id = Tq/o
// module chunks = 0 1 2 6